import React from "react";
import { useHistory,Link } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  const handleLogout = () => {
    localStorage.clear();
    history.push("/login");
  };
  return (
    <div className="header-dashboard">
      <div className="wrap">
        <div className="header-left">
          <Link to="/">
            <img
              className=""
              id="logo_header_mobile"
              alt=""
              src="assets/images/logo/sachi_logo.jpeg"
              data-light="images/logo/logo.png"
              data-dark="images/logo/logo-dark.png"
              data-width="154px"
              data-height="52px"
              data-retina="images/logo/logo@2x.png"
            />
          </Link>
          <div className="button-show-hide">
            <i className="icon-menu-left"></i>
          </div>
          <form className="form-search flex-grow">
            <fieldset className="name">
              <input
                type="text"
                placeholder="Search here..."
                className="show-search"
                name="name"
                tabIndex="2"
                value=""
                aria-required="true"
                required=""
              />
            </fieldset>
            <div className="button-submit">
              <button className="" type="submit">
                <i className="icon-search"></i>
              </button>
            </div>
            <div className="box-content-search" id="box-content-search">
              <ul className="mb-24">
                <li className="mb-14">
                  <div className="body-title">Top selling product</div>
                </li>
                <li className="mb-14">
                  <div className="divider"></div>
                </li>
                <li>
                  <ul>
                    <li className="product-item gap14 mb-10">
                      <div className="image no-bg">
                        <img src="images/products/17.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Dog Food Rachael Ray Nutrish®
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="mb-10">
                      <div className="divider"></div>
                    </li>
                    <li className="product-item gap14 mb-10">
                      <div className="image no-bg">
                        <img src="images/products/18.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Natural Dog Food Healthy Dog Food
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="mb-10">
                      <div className="divider"></div>
                    </li>
                    <li className="product-item gap14">
                      <div className="image no-bg">
                        <img src="images/products/19.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Freshpet Healthy Dog Food and Cat
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="">
                <li className="mb-14">
                  <div className="body-title">Order product</div>
                </li>
                <li className="mb-14">
                  <div className="divider"></div>
                </li>
                <li>
                  <ul>
                    <li className="product-item gap14 mb-10">
                      <div className="image no-bg">
                        <img src="images/products/20.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Sojos Crunchy Natural Grain Free...
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="mb-10">
                      <div className="divider"></div>
                    </li>
                    <li className="product-item gap14 mb-10">
                      <div className="image no-bg">
                        <img src="images/products/21.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Kristin Watson
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="mb-10">
                      <div className="divider"></div>
                    </li>
                    <li className="product-item gap14 mb-10">
                      <div className="image no-bg">
                        <img src="images/products/22.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Mega Pumpkin Bone
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li className="mb-10">
                      <div className="divider"></div>
                    </li>
                    <li className="product-item gap14">
                      <div className="image no-bg">
                        <img src="images/products/23.png" alt="" />
                      </div>
                      <div className="flex items-center justify-between gap20 flex-grow">
                        <div className="name">
                          <Link to="product-list.html" className="body-text">
                            Mega Pumpkin Bone
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </form>
        </div>
        <div className="header-grid">        
          <div className="popup-wrap user type-header">
            <div className="dropdown">
              <button
                onClick={handleLogout}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ff4d4f",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
